module.exports = __webpack_public_path__ + "static/media/boothBg.c3627929.png";